import React from "react";
import { FunctionField, ReferenceField } from "react-admin";

import { OrderReferenceChip } from "./OrderReferenceChip";

export const OrderReferenceField = ({ source, label, record, ...rest }) => {
	if (!record?.[source]) return null;

	return (
		<ReferenceField
			reference="orders"
			source={source}
			label={label}
			record={record}
			allowEmpty={true}
			link={false}
			{...rest}
		>
			<FunctionField
				render={(record) =>
					record?.reference ? (
						<OrderReferenceChip orderId={record.id} reference={record.reference} />
					) : null
				}
			/>
		</ReferenceField>
	);
};
